import { css } from "@emotion/react";

export const playlistsContainer = css`
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
  background: #1f1f1f;
  min-height: 100vh;
`;

export const emptyContainer = css`
  text-align: center;
  padding: 40px;
  background: #2d2d2d;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  color: #e0e0e0;

  .ant-empty-description {
    color: #e0e0e0;
  }

  .ant-empty-img-simple-path {
    fill: #4a4a4a;
  }

  .ant-empty-img-simple-ellipse {
    fill: #3a3a3a;
  }
`;

export const playlistItem = css`
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  padding: 15px;
  border-radius: 8px;
  background: #2d2d2d;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid transparent;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
    border-color: #4a4a4a;
    background: #333333;
  }
`;

export const thumbnailContainer = css`
  flex-shrink: 0;
  width: 180px;
  height: 100px;
  overflow: hidden;
  border-radius: 4px;
  background: #1a1a1a;
  border: 1px solid #3a3a3a;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.2s ease;

    &.loading {
      opacity: 0;
    }

    &.loaded {
      opacity: 1;
    }
  }

  .placeholder {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #4a4a4a;
    font-size: 24px;
  }

  @media (max-width: 769px) {
    width: 120px;
    height: 80px;
  }
`;

export const playlistInfo = css`
  flex-grow: 1;
  overflow: hidden;

  h3 {
    margin: 0 0 8px;
    font-size: 18px;
    color: #e0e0e0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  p {
    margin: 0;
    color: #b0b0b0;
    font-size: 14px;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .video-count {
    color: #808080;
    font-size: 12px;
    margin-top: 8px;
  }
`;

export const paginationContainer = css`
  margin-top: 30px;
  text-align: center;

  .ant-pagination {
    .ant-pagination-item {
      background: #2d2d2d;
      border-color: #4a4a4a;
      a {
        color: #e0e0e0;
      }

      &:hover {
        border-color: #1890ff;
        a {
          color: #1890ff;
        }
      }

      &-active {
        background: #1890ff;
        border-color: #1890ff;
        a {
          color: white;
        }
      }
    }

    .ant-pagination-prev,
    .ant-pagination-next {
      button {
        background: #2d2d2d;
        border-color: #4a4a4a;
        color: #e0e0e0;

        &:hover {
          border-color: #1890ff;
          color: #1890ff;
        }
      }
    }
  }
`;

export const loadingContainer = css`
  text-align: center;
  min-height: 100vh;
`;

export const darkLoadingContainer = css`
  ${loadingContainer}
  background: #1f1f1f;
  padding-top: 40vh;

  .ant-spin {
    .ant-spin-dot-item {
      background-color: #1890ff;
    }
  }
`;

export const bookmarkIcon = css`
  font-size: 24px;
  color: #ffffff;
`;

export const title = css`
font-size: 1.75rem;
font-weight: 600;
margin-bottom: 2rem;
padding: 1rem 0;
color: white;
`;

export const emptyStateContainer = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1rem;
  // background: #2d2d2d;
  background: #2d2d2d47;
  border-radius: 8px;
  margin-bottom: 2rem;
`;

export const emptyStateHeader = css`
  font-size: 1.3rem;
  font-weight: 600;
  color: #e0e0e0;
  margin-bottom: 1rem;
  text-align: center;
`;

export const underlinedText = css`
  text-decoration: underline;
  text-underline-offset: 4px;
`;

export const highlightedText = css`
  background: linear-gradient(104deg, rgba(72, 57, 125, 0.4) 0%, rgba(46, 103, 141, 0.3) 100%);
  color: #ffffff;
  font-weight: 600;
  font-size: 1.3rem;
  padding: 0.5rem 0.5rem;
  border-radius: 5px;
  // border-left: 1px solid rgb(46, 103, 141);
  display: inline-block;
  margin-bottom: 0.5rem;
`;

export const accentText = css`
  font-weight: 600;
  font-style: italic;
  background: linear-gradient(to right, #6dd5ed, #2193b0);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-shadow: 0px 0px 8px rgba(33, 147, 176, 0.2);
  padding: 0 4px;
`;

export const accentTextAlt = css`
  font-weight: 600;
  font-style: italic;
  background: linear-gradient(to right,rgb(176, 102, 255),rgb(98, 140, 213)); /* Orange-pink gradient */
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-fill-color: transparent;
  text-shadow: 0px 0px 8px rgba(255, 94, 98, 0.2);
  padding: 0 4px;
`;

export const demoText = css`
  display: inline-block;
  margin-top: 0.75rem;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 600;
  // background: rgba(72, 57, 125, 0.15);
  // border-left: 2px solid #6dd5ed;
  // border-right: 2px solid #2193b0;
  border: 1px solid #6dd5ed;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
  
`;

export const instructionsText = css`

  // background: #2d2d2d47;
  // padding: 30px;

  color: #d3d3d3;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  line-height: 1.5;
  font-size: 1.2rem;
  text-align: center;
  
  /* Add consistent spacing between paragraphs and list */
  br + ol,
  br + p {
    margin-top: 1rem;
  }
  
  ol {
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 1.5rem;
  }
  
  li {
    margin-bottom: 0.1rem;
    margin-left: 1rem;
  }
`;

export const videoEmbedContainer = css`
  width: 100%;
  max-width: 640px;
  margin: 2rem auto;
`;

export const addPlaylistButton = css`
  min-width: 140px;
  height: 40px;
  border-radius: 20px;
  background: #1890ff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  margin: 18px auto 18px;
  transition: all 0.3s ease;
  padding: 0 20px;
  
  &.active {
    background: #555555;
  }
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
  }
  
  &:active {
    transform: scale(0.98);
  }
`;

export const addPlaylistModalContainer = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const addPlaylistModalContent = css`
  background: #2d2d2d;
  border-radius: 8px;
  padding: 2rem;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
  position: relative;
`;

export const modalCloseButton = css`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
  border: none;
  color: #b0b0b0;
  font-size: 20px;
  cursor: pointer;
  
  &:hover {
    color: #e0e0e0;
  }
`;

export const centeredUrlRequestContainer = (height: string = '60vh') => css`
  /* Use grid for perfect centering that accounts for component height */
  display: grid;
  place-items: center; /* This is the magic for true vertical and horizontal centering */
  width: 100%;
  height: ${height}; /* Use percentage of viewport height */
  margin-bottom: 2rem;
  
  /* Ensure the SummarizationURLRequest component keeps its full width */
  > * {
    width: 100%;
    max-width: 800px;
  }
`;
export const homepageBrandingBannerContainer = css`
display: flex;
justify-content: space-between;
align-items: center;
width: 100%;
margin-bottom: 16px;
padding-top: 8px;
`;

export const homepageBrandingBanner = css`
margin-bottom: 0;
flex-grow: 1;
`;


export const homepageCornerPlusIcon = css`
font-size: 1.2rem;
width: 40px;
height: 38px;
border-radius: 50%;
background-color: #5c575d;
display: flex;
align-items: center;
justify-content: center;
cursor: pointer;
transition: background-color 0.2s ease;
&:hover {
  background-color: #6c676d;
}
`